import React from 'react'
import { removeHtmlTagsAndEntities, truncateText } from '../../utils';
import moment from 'moment';
import MuiTable from "../admin/board/components/BoardTable/MuiTbale";

export const ListViewTable = ({projects=[], getCradStatus,columns,selectedColumn}) => {
  return (
    <>
          <MuiTable
                subHeight={"210"}
                initialRows={
                  projects
                    ? projects?.map((ele) => {
                      return {
                        id: ele?.card?.card_id,
                        col1: ele,
                        col2: ele?.card?.title,
                        col3: ele?.card?.workflow_step_id
                          ? getCradStatus(ele?.card?.workflow_step_id)
                          : "",
                        col4: ele?.card?.description
                          ? truncateText(
                            removeHtmlTagsAndEntities(
                              ele?.card?.description
                            ),
                            85
                          )
                          : "",
                        col5: ele,
                        col6: ele?.labels?.join(", "),
                        // col7: ele?.card?.epic?.epic_name,
                        col7: ele,
                        col8: ele?.card?.allocated_hours,
                        col9: ele?.total_hours_spent,
                        col10: {
                          hoursSpent: ele?.total_hours_spent,
                          allotedHours: ele?.card?.allocated_hours,
                        },
                        col11: ele?.card?.due_date
                          ? moment(ele?.card?.due_date)
                            .local()
                            .format("MMMM D,YYYY")
                          : "",
                        col12: ele?.card?.date_created
                          ? moment(ele?.card?.date_created)
                            .local()
                            .format("MMMM D,YYYY")
                          : "",
                        col13: ele,
                      };
                    })
                    : []
                }
                columns={columns?.filter((ele) => selectedColumn[ele?.field])}
              />
    </>
  )
}

